export const readChatSSEFrames = async (messageResponse, onFrame) => {
  const reader = messageResponse.body.getReader();
  const decoder = new TextDecoder();
  let sseBuffer = '';
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    sseBuffer += decoder.decode(value, { stream: true });
    let sepIndex;
    while ((sepIndex = sseBuffer.indexOf('\n\n')) !== -1) {
      const frame = sseBuffer.slice(0, sepIndex).trim();
      sseBuffer = sseBuffer.slice(sepIndex + 2);
      if (!frame.startsWith('data:')) continue;
      try { onFrame(JSON.parse(frame.replace(/^data:\s*/, ''))); } catch { /* skip malformed frame */ }
    }
  }
};

export const replaceChatMessageText = (message, value) => {
  const [firstPart = {}, ...remainingParts] = Array.isArray(message.content)
    ? message.content
    : [];

  return {
    ...message,
    content: [
      {
        ...firstPart,
        text: {
          ...(firstPart.text || {}),
          value,
        },
      },
      ...remainingParts,
    ],
  };
};

const updateLastAssistantMessage = (messages, updateMessage) => {
  const lastIndex = messages.length - 1;
  const last = messages[lastIndex];
  if (!last || last.role !== "assistant") return messages;

  return [
    ...messages.slice(0, lastIndex),
    updateMessage(last),
  ];
};

export const handleChatMessage = async (messageResponse, setThinkingFeed, setChatMessages) => {
  let terminalPayload;

  await readChatSSEFrames(messageResponse, (payload) => {
    if (payload.type === "thinking") {
      setThinkingFeed((prev) => [
        ...prev,
        {
          stage: payload.stage,
          name: payload.name,
          text: payload.label || (payload.name ? `Using ${payload.name}...` : "Working..."),
          argsPreview: payload.argsPreview,
        },
      ]);
      return;
    }

    if (payload.type === "assistant_delta") {
      setChatMessages((prev) => updateLastAssistantMessage(prev, (last) => (
        replaceChatMessageText(
          last,
          `${last.content?.[0]?.text?.value || ""}${payload.text || ""}`,
        )
      )));
      return;
    }

    if (payload.type === "assistant_final") {
      setChatMessages((prev) => updateLastAssistantMessage(prev, (last) => (
        replaceChatMessageText(last, payload.text || "")
      )));
      return;
    }

    // Callers need the terminal frame to decide whether a previously
    // degraded composer can recover. A stream opening or receiving a delta
    // is not proof that the turn completed successfully.
    if (payload.type === "chat_complete" || payload.error) {
      terminalPayload = payload;
      return;
    }

    // Responses handles advance on the server before its terminal frame, so
    // the browser deliberately has no persistence callback to receive one.
    if (payload.type === "message_id") {
      setChatMessages((prev) => updateLastAssistantMessage(prev, (last) => ({
        ...last,
        id: payload.id,
      })));
    }
  });

  return terminalPayload;
}
